import { render, staticRenderFns } from "./messageGroupItem.vue?vue&type=template&id=d42d3ab2"
import script from "./messageGroupItem.vue?vue&type=script&lang=js"
export * from "./messageGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports